<template>
    <div class="map-container">
        <!-- 地图头部控制栏 -->
        <div class="map-header">
            <!-- 返回按钮 -->
            <div class="back-btn" @click="goBack">
                <i class="el-icon-arrow-left"></i>
            </div>
            
            <!-- 搜索框 -->
            <div class="search-box">
                <el-input
                    v-model="searchKeyword"
                    placeholder="输入项目ID搜索"
                    class="search-input"
                    @keyup.native.enter="handleSearch"
                >
                    <i  v-if="searchKeyword" slot="suffix" class="el-icon-close search-icon" @click="cleanSerach"></i>
                </el-input>
            </div>
            
            
            
            <!-- 日期选择器 -->
            <div class="date-selector">
                <el-date-picker
                    v-model="selectedDate"
                    type="month"
                    placeholder="选择月份"
                    format="yyyy年MM月"
                    value-format="yyyy-MM"
                    @change="handleDateChange"
                >
                </el-date-picker>
            </div>
            
            <!-- 数据统计框 -->
            <div class="data-stats">
                <div class="stats-label">{{ getFilterLabel() }}</div>
                <div class="stats-count">{{ projectData.all }}</div>
            </div>
        </div>
        
        <!-- 地图容器 -->
        <div id="map"></div>
        
        <!-- iframe弹窗 -->
        <div v-if="showIframe" class="iframe-modal" @click="closeIframe">
            <div class="iframe-container" @click.stop>
                <div class="iframe-header">
                    <span class="iframe-title">{{ currentProject.title }}</span>
                    <i class="el-icon-close close-btn" @click="closeIframe"></i>
                </div>
                <iframe 
                    :src="iframeUrl"
                    width="100%" 
                    height="100%" 
                    frameborder="0"
                    class="iframe-content"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import common from '@/utils/common'

export default {
    name: 'JiaofuMap',
    data() {
        return {
            map: null,
            searchKeyword: '',
            activeFilter: 'all',
            selectedDate: '',
            projectData: {
                all: 0,
                delivering: 0,
                completed: 0
            },
            projectList: [],
            markers: [],
            hasInitialized: false,
            showIframe: false,
            currentProject: {},
            iframeUrl: '',
            token: ''
        }
    },
    mounted() {
        //年-月
        let month = new Date().getMonth()+1;
        month = month<10?'0'+month:month;
        this.selectedDate = new Date().getFullYear()+'-'+month;
        this.token = localStorage.getItem('token');
        this.initMap();
        this.loadMapData();
        
    },
    methods: {
        cleanSerach(){
            this.searchKeyword = '';
            this.loadMapData();
            
        },
        loadMapData() {
            const params = {
                status_filter: this.activeFilter,
                search_keyword: this.searchKeyword,
                date_filter: this.selectedDate||''
            };
            
            common.connect('/distributorpcv1/jiaofu/map_data', params, (res) => {
                this.projectList = res.data.list;
                
                this.projectData = res.data.stats ;
                console.log(this.projectData);
                this.addMarkersToMap();
            });
        },
        initMap() {

            window._AMapSecurityConfig = {
                securityJsCode: "a28081a8b4b5a6eb9705f333f76400b3",
            };

            AMapLoader.load({
                "key": "38baee6da4c9419a791b6b03a9a38e8f", // 申请好的Web端开发者Key，首次调用 load 时必填
                "version": "2.0", // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
                "plugins": [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
                this.map = new AMap.Map('map', {
                    center: [116, 30],
                    zoom: 5,
                    mapStyle: 'amap://styles/dark'
                });
                console.log(this.map);
                this.map.setMapStyle("amap://styles/dark");
            });

        },
        
        // 添加标记到地图
        addMarkersToMap() {
            // 清除现有标记
            this.clearMarkers();
            if (!this.map || !this.projectList.length) return;
            
            
            
            this.projectList.forEach(project => {
                if (project.longitude && project.latitude) {
                    const iconUrl = project.status === 8 
                        ? require('@/assets/images/map_jf_done.png')
                        : require('@/assets/images/map_jf.png');
                    
                    const marker = new AMap.Marker({
                        position: [parseFloat(project.longitude), parseFloat(project.latitude)],
                        icon: new AMap.Icon({
                            size: new AMap.Size(32, 32),
                            image: iconUrl,
                            imageSize: new AMap.Size(32, 32)
                        }),
                        title: project.title
                    });
                    
                    // 添加点击事件
                    marker.on('click', () => {
                        this.showProjectDetail(project);
                    });
                    
                    this.map.add(marker);
                    this.markers.push(marker);
                }
            });
            
            
        },
        
        // 清除地图标记
        clearMarkers() {
            this.markers.forEach(marker => {
                this.map.remove(marker);
            });
            this.markers = [];
        },
        
        // 返回上一页
        goBack() {
            this.$router.go(-1)
        },
        
        // 处理搜索
        handleSearch() {
            console.log('搜索项目:', this.searchKeyword)
            this.loadMapData();
            setTimeout(()=>{
                if(this.projectList.length==1){
                    this.showProjectDetail(this.projectList[0]);
                }
            },1000);
        },
        
        // 设置筛选条件
        setFilter(filter) {
            this.activeFilter = filter
            console.log('当前筛选条件:', filter)
            this.loadMapData();
        },
        
        // 处理日期变化
        handleDateChange(date) {
            console.log('选择日期:', date)
            this.loadMapData();
        },
        
        // 获取筛选标签
        getFilterLabel() {
            const labels = {
                all: '全部',
                delivering: '交付中',
                completed: '已完工'
            }
            return labels[this.activeFilter] || '全部'
        },
        
        
        
        // 显示项目详情
        showProjectDetail(project) {
            this.currentProject = project;
            this.iframeUrl = `https://c.taocitong.top/ent_mob_frame/#/pages/plugin/customer_center/project_progress?id=${project.id}`;
            this.showIframe = true;
        },
        
        // 关闭iframe弹窗
        closeIframe() {
            this.showIframe = false;
            this.currentProject = {};
            this.iframeUrl = '';
        }
    }
    
}
</script>

<style scoped>
.map-container {
    position: relative;
    width: 100%;
    height: 100vh;
}

.map-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    padding: 15px 20px;
   
}

.back-btn {
    width: 40px;
    height: 40px;
    background: #606266;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 15px;
    transition: background-color 0.3s;
}

.back-btn:hover {
    background: #909399;
}

.back-btn i {
    color: white;
    font-size: 18px;
}

.search-box {
    flex: 1;
    max-width: 300px;
    margin-right: 20px;
}

.search-input {
    width: 100%;
}

.search-input >>> .el-input__inner {
    border-radius: 20px;
    padding-left: 15px;
    padding-right: 40px;
}

.search-input >>> .el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    right: 10px;
}

.search-icon {
    cursor: pointer;
    color: #909399;
    transition: color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.search-icon:hover {
    color: #409EFF;
}

.filter-buttons {
    display: flex;
    gap: 10px;
    margin-right: 20px;
}

.filter-buttons .el-button {
    border-radius: 20px;
    padding: 8px 20px;
    border: 1px solid #dcdfe6;
    background: #f5f7fa;
    color: #606266;
    transition: all 0.3s;
}

.filter-buttons .el-button.active,
.filter-buttons .el-button--primary {
    background: #67C23A;
    border-color: #67C23A;
    color: white;
}

.filter-buttons .el-button:hover:not(.active):not(.el-button--primary) {
    background: #ecf5ff;
    border-color: #b3d8ff;
    color: #409EFF;
}

.date-selector {
    margin-right: 20px;
}

.date-selector >>> .el-input__inner {
    border-radius: 20px;
   
    padding-right: 40px; /* 增加右侧内边距，为图标留出空间 */
}



.date-selector >>> .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
}

.data-stats {
    background: #606266;
    color: white;
    padding: 6px 20px;
    border-radius: 8px;
    text-align: center;
    min-width: 80px;
}

.stats-label {
    font-size: 12px;
    margin-bottom: 5px;
    opacity: 0.8;
}

.stats-count {
    font-size: 24px;
    font-weight: bold;
}

#map {
    width: 100%;
    height: 100%;
    min-height: 800px;
}

/* iframe弹窗样式 */
.iframe-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.iframe-container {
    width: 375px;
    height: 600px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    right: 30px;
}

.iframe-header {
    height: 50px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

.iframe-title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.close-btn {
    font-size: 18px;
    color: #909399;
    cursor: pointer;
    padding: 5px;
    transition: color 0.3s;
}

.close-btn:hover {
    color: #409EFF;
}

.iframe-content {
    flex: 1;
    border: none;
    display: block;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .map-header {
        flex-wrap: wrap;
        padding: 10px 15px;
    }
    
    .search-box {
        max-width: 250px;
        margin-right: 15px;
    }
    
    .filter-buttons {
        margin-right: 15px;
    }
    
    .date-selector {
        margin-right: 15px;
    }
}

@media (max-width: 768px) {
    .map-header {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
    
    .search-box {
        max-width: none;
        margin-right: 0;
    }
    
    .filter-buttons {
        justify-content: center;
        margin-right: 0;
    }
    
    .date-selector {
        margin-right: 0;
    }
    
    .data-stats {
        align-self: center;
    }
}
</style>